import React, { Dispatch, SetStateAction } from 'react';
import { toast } from 'sonner';
import { ScoutLocation } from '@/types/location';
import { deregisterLocations } from '@/api/location';
import * as Toast from '@/components/ui/toast/Toast';
import { useUser } from '@/hooks/useUser';

interface RemoveLocationProps {
  id: string;
  setLocations: Dispatch<SetStateAction<ScoutLocation[]>>;
  callback?: () => void;
}

const RemoveLocation: React.FC<RemoveLocationProps> = ({
  id,
  setLocations,
  callback,
}) => {
  const { user } = useUser();

  return (
    <div
      className="cursor-pointer text-destructive"
      onClick={async () => {
        const response = await deregisterLocations(
          [id],
          user?.currentOrganization,
        );

        if ('error' in response) {
          console.error(response.error);

          let title = 'Try Again';
          let description =
            'We were unable to remove the location, please try again.';

          if (typeof response.error === 'object') {
            const { message } = response.error;
            if (
              message.includes(
                'Failed to deregister locations with active bursts',
              )
            ) {
              title = 'Unable to Remove';
              description =
                'The location has an active burst and cannot be removed.';
            }
          }

          toast.custom(t => (
            <Toast.Default
              title={title}
              description={description}
              buttons={[
                {
                  label: 'Dismiss',
                  onClick: () => toast.dismiss(t),
                  variant: 'secondary',
                  size: 'fw',
                },
              ]}
            />
          ));
          return;
        }

        toast.custom(t => (
          <Toast.Default
            title="Location Removed"
            description="The location has been successfully removed."
            buttons={[
              {
                label: 'Dismiss',
                onClick: () => {
                  toast.dismiss(t);
                },
                variant: 'secondary',
                size: 'fw',
              },
            ]}
          />
        ));

        setLocations(prevState => prevState.filter(loc => loc._id !== id));
        callback && callback();
      }}>
      Remove Location
    </div>
  );
};

export default RemoveLocation;
